import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';
import CreateButton from '../../core/CreateButton';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Component, default as React } from 'react';
import ActionText from '../../core/ActionText';
import ConceptData from '../taxonomies/ConceptData';
import CollectionStructure from './CollectionStructure';
import FindConceptDialog from './FindConceptDialog';
import SearchCollection from './SearchCollection';
import { globalStyles } from '../../core/style/gstheme';
import GetStarted from '../../application-core/GetStarted';

const styles = Object.assign({}, globalStyles);

class CollectionView extends Component {

  render() {

    const { activeConcept, classes, skosXL, data, onDeleteConcept, project,
      showLabelDetail, onSelectViewLanguage, viewLang,
      defaultLang, onSelect, onBreakLink, isReadOnly, onIncludeExistingConcept,
      appBar, graph, showFloatingLabel, entitlements } = this.props;
      
    const memberProp = data.type.includes("OrderedCollection") ? "memberList" : "member";

    return (
      <div>
        <div className={classes.controlPanel}>
          <div className={classes.views}>
            {appBar}
          </div>
          <div className={classes.controlPanelInner}>
            <div className={classes.controlPanelAdd}>
              {!isReadOnly && data[memberProp] && data[memberProp].length > 0 &&
                <FindConceptDialog
                  graph={graph}
                  onIncludeConcept={onIncludeExistingConcept}
                  exclude={data[memberProp]} />
              }
            </div>
            <div className={classes.controlPanelSearch}>
              {data[memberProp] && data[memberProp].length > 0 &&
                <SearchCollection
                  skosXL={skosXL}
                  ordered={memberProp === "memberList"}
                  project={project}
                  graph={graph}
                  collectionIRI={data.id}
                  lang={defaultLang}
                  returnConcept={onSelect} />
              }
            </div>
          </div>
          <div data-test="concept-tree" className={classes.tree}>
            {data[memberProp] && data[memberProp].length > 0 ?
              <CollectionStructure
                lang={defaultLang}
                id={data.id}
                graph={graph}
                ordered={memberProp === "memberList"}
                activeConcept={activeConcept}
                isReadOnly={isReadOnly}
                viewLang={viewLang}
                version={data._version}
                concepts={data[memberProp]}
                onSelect={onSelect}
                onBreakLink={onBreakLink}
              />
              :
              (isReadOnly ?
                <ActionText offset="85px">No concepts.</ActionText>
                :
                <GetStarted text="Add a concept to get started." action={
                  <FindConceptDialog
                    button={<CreateButton label="Add" />}
                    graph={graph}
                    onIncludeConcept={onIncludeExistingConcept}
                    exclude={data[memberProp]} />
                } />
              )
            }
          </div>
        </div>
        <div data-test="view-language" className={classes.viewLanguagePanel}>
          <ProjectLanguageSelector includeLabel={false} onSelect={onSelectViewLanguage} />
        </div>
        <div data-test="info-panel" className={classes.infoPanel}>
          {activeConcept === null ?
            <ActionText offset="180px">Select a concept to view the detail.</ActionText>
            :
            <ConceptData
              key={activeConcept}
              handleNotAvailable={true}
              id={activeConcept}
              entitlements={entitlements}
              graph={graph}
              propertyTemplates={data.associatedTemplate}
              hiddenProps={data.hiddenProp}
              showFloatingLabel={showFloatingLabel}
              showLabelDetail={showLabelDetail}
              conceptIRI={activeConcept}
              viewLang={viewLang}
              project={project}
              isReadOnly={true}
              onDeleteConcept={onDeleteConcept} />}
        </div>
      </div>
    );
  }
}

CollectionView.propTypes = {
  classes: PropTypes.object,
  activeConcept: PropTypes.string,
  appBar: PropTypes.object.isRequired,
  entitlements: PropTypes.array.isRequired,
  onIncludeExistingConcept: PropTypes.func.isRequired,
  onDeleteConcept: PropTypes.func.isRequired,
  skosXL: PropTypes.bool.isRequired,
  project: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  showFloatingLabel: PropTypes.func.isRequired,
  showLabelDetail: PropTypes.func.isRequired,
  onSelectViewLanguage: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  viewLang: PropTypes.string,
  onBreakLink: PropTypes.func.isRequired,
  defaultLang: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
};

export default withStyles(styles)(CollectionView);